import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';


export interface GetAccountCollectionsListVars {
    awsAccountId: String;
    collectionGroupName: String;
}

const GET_ACCOUNT_COLLECTION_LIST = gql`
    query GetAccountCollectionsList(
            $awsAccountId: String
            $collectionGroupName: String
        ){
        getAccountCollectionsList(
            awsAccountId: $awsAccountId
            collectionGroupName: $collectionGroupName
        )
    }
`;

export const useGetAccountCollectionsListQuery = () => {
    return useLazyQuery<AnyObject, GetAccountCollectionsListVars>(GET_ACCOUNT_COLLECTION_LIST, {
        errorPolicy: 'all',
    });
};
